import {
  Box,
  Button, Card, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, List, ListItem, Paper, Radio, RadioGroup, Typography,
} from '@mui/material';
import * as React from 'react';

interface IApprovalDialog {
  open: boolean;
  onClose: () => void;
  onSelection: (selection: string | null | undefined, type: string | null | undefined) => void;
  textOptions: (string | null | undefined)[];
  typeOptions: (string | null | undefined)[];
  primaryColor: string | undefined | null;
  secondaryColor: string | undefined | null;
}
function ApprovalDialog({
  open, onClose, onSelection, textOptions, typeOptions, primaryColor = 'lightGrey', secondaryColor = 'gray',
} : IApprovalDialog) {
  const [textSelection, setTextSelection] = React.useState<{ option: string | null | undefined, index: number }>();
  const [typeSelection, setTypeSelection] = React.useState<{ option: string | null | undefined, index: number }>();

  React.useEffect(() => {
    if (textOptions?.length === 1) {
      setTextSelection({ option: textOptions[0], index: 0 });
    }
  }, [textOptions]);

  return (

    <Dialog
      maxWidth="lg"
      open={open}
      onClose={onClose}
    >
      <Box p={3}>
        {typeOptions?.length > 0 && (
        <Box p={1} mb={1} borderRadius={2} bgcolor={primaryColor ?? 'lightgray'}>
          <Box>
            <DialogTitle sx={{ textAlign: 'center', bgcolor: primaryColor }}>
              Select the type of FAA notification.
            </DialogTitle>
            <Card>
              <DialogContent>
                <DialogContentText>
                  <FormControl>
                    <RadioGroup
                      value={`${typeSelection?.option},,,${typeSelection?.index}`}
                      onChange={(e, value) => {
                        const values = value.split(',,,');
                        const option = values[0];
                        const index = Number(values[1]);
                        setTypeSelection({ option, index });
                      }}
                    >
                      {typeOptions.map((option, index) => (
                        <FormControlLabel
                          // eslint-disable-next-line react/no-array-index-key
                          key={`${option ?? ''}${index}`}
                          value={`${option ?? ''},,,${index}`}
                          control={<Radio />}
                          label={option}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </DialogContentText>
              </DialogContent>
            </Card>
          </Box>
        </Box>
        )}
        {textOptions?.length > 1 && (
        <Box p={1} borderRadius={2} bgcolor={primaryColor ?? 'lightgray'}>
          <Box>
            <DialogTitle sx={{ textAlign: 'center', bgcolor: primaryColor }}>
              Select which narrative to send to the FAA.
            </DialogTitle>
            <Card>
              <DialogContent>
                <DialogContentText>
                  <FormControl>
                    <RadioGroup
                      value={`${textSelection?.option},,,${textSelection?.index}`}
                      onChange={(e, value) => {
                        const values = value.split(',,,');
                        const option = values[0];
                        const index = Number(values[1]);
                        setTextSelection({ option, index });
                      }}
                    >
                      {textOptions.map((option, index) => (
                        <FormControlLabel
                          // eslint-disable-next-line react/no-array-index-key
                          key={`${option ?? ''}${index}`}
                          value={`${option ?? ''},,,${index}`}
                          control={<Radio />}
                          label={option}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </DialogContentText>
              </DialogContent>
            </Card>
          </Box>
        </Box>
        )}
        <DialogActions>
          <Button onClick={onClose} autoFocus>Cancel</Button>
          <Button
            disabled={!textSelection || !typeSelection}
            onClick={() => {
              onSelection(textSelection?.option, typeSelection?.option);
              onClose();
            }}
            color="primary"
          >
            Approve with Selection
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

export default ApprovalDialog;
